<div class="cx-modal-container">
  <div class="cx-modal-content">
<div class="modal-header checkout-popup-header">
  <h4 class="modal-title" id="modal-basic-title"> {{ "bulkorder.bulkitem" | cxTranslate }}</h4>
</div>
<div class="modal-body checkout-popup">
  <h3 class="confirmation-order"> {{ "bulkorder.bulkshopping" | cxTranslate }}</h3>
  <!-- 
  <div class="vs-checkbox custom-order-checkbox" *ngIf="getFailuresCount > 0">
    <i class="material-icons custom-material-icon">report_problem</i>
    <p class="confirmation-order">
      Some parts could not be added. Please update as mentioned or request for
      quote.
    </p>
  </div> -->

  <div
    class="vs-checkbox custom-order-checkbox"
    *ngIf="priceNotAvailableinSAPProducts.length > 0"
  >
    <i class="material-icons custom-material-icon">report_problem</i>
    <p class="confirmation-order">
      <span *ngFor="let item of priceNotAvailableinSAPProducts; let i = index">
        {{ "bulkorder.bulkpart" | cxTranslate }}  {{ item
        }}<span *ngIf="i < priceNotAvailableinSAPProducts.length - 1">,</span>
      </span>
      <span> {{ "bulkorder.bulkorderprice" | cxTranslate }} </span>
    </p>
  </div>
</div>
<div class="modal-footer checkout-popup-footer">
  <button
    (click)="sendSuccessFlag(); dismissModal('OK')"
    class="vs-primary-btn sample-btn footer-text-btn"
  >
  {{ "bulkorder.okbtn" | cxTranslate }}
  </button>
</div>
</div>
</div>
